import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import { useIsClient } from '@/hooks/useIsClient';
import { AB_TEST_COOKIE } from '@/utility/constants';
const getOldAbTests = (): string[] => {
  try {
    const abTests = document.cookie.split('; ').find(row => row.startsWith(`${AB_TEST_COOKIE}=`));
    if (!abTests) {
      return [];
    }
    const value = abTests.split('=')[1];
    return value ? decodeURIComponent(value).split(',') : [];
  } catch {
    return [];
  }
};

/**
 * @deprecated use kameleoon a/b testing solution instead (see abTestConfigAtom.ts)
 */
export const useOldAbTests = () => {
  const $ = _c(2);
  const isClient = useIsClient();
  let t0;
  if ($[0] !== isClient) {
    t0 = isClient ? getOldAbTests() : [];
    $[0] = isClient;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};